// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eI-z","hovered":"fI-z","hoverImage":"gI-z","mainImage":"hI-z","imageNoBackground":"iI-z","fullSizeImage":"jI-z"};